import { Component } from '@angular/core';

@Component({
  templateUrl: 'discountrequested.component.html'
})
export class DiscountrequestedComponent {

  constructor() { 

  } 
}


// WEBPACK FOOTER //
// ./src/app/agencies/discountrequested.component.ts